<template>
  <div>
    <div>

      <instCheckBox :fieldName="'AGREEMENT_EASY_DRAFT_IU'">
        <template v-slot:content>
          <p>
            Я ознакомлен и согласен со
            <a href="" v-on:click="agreementVisibleToggle">следующим</a>
          </p>
        </template>
      </instCheckBox>

    </div>
    <div v-show="agreementVisible" class="agreementDesc">
      <instCheckBox :fieldName="'AGREEMENT_IU'">
        <template v-slot:content>
          <p>Индивидуальные условия <a :href="uiUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_PDN'">
        <template v-slot:content>
          <p>Согласие ПДН <a :href="pdnUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_ANKETA'">
        <template v-slot:content>
          <p>Заявление-анкета заемщика <a :href="anketaUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_RECURENT'"></instCheckBox>


      <div class="instInputWrap" v-if="absoluteBoxValue">
        <div class="instCheckBoxFlexWrap">
          <div class="instCheckBoxWrap">
            <input type="checkbox" v-model="absoluteBoxValue.isActive" :true-value="1" :false-value="0">
            <svg viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:style="{fill:calcFill}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.504.43C12.767.359 14.027.365 15.29.365h6.396c1.287 0 2.548-.006 3.81.067 1.147.065 2.264.205 3.376.517a11.075 11.075 0 015.864 3.968 11.098 11.098 0 010 13.44 11.08 11.08 0 01-5.864 3.97c-1.112.311-2.23.45-3.376.516-1.262.073-2.523.067-3.785.067h-6.398c-1.286 0-2.546.006-3.809-.067-1.146-.066-2.263-.205-3.376-.517A11.08 11.08 0 010 11.637a11.1 11.1 0 012.265-6.72A11.076 11.076 0 018.128.946c1.113-.311 2.23-.45 3.376-.516z"/></svg>
            <div class="instCheckBoxMarker" v-bind:class="{trueValue: absoluteBoxValue.isActive === 1}"></div>
          </div>
          <p>
            <span>Страхование физических лиц от несчастных случаев и болезней. </span>
            <a href="" v-on:click="absoluteBoxInfo" v-show="!absoluteBoxInfoFlag">Подробнее </a>
            <span v-show="absoluteBoxInfoFlag">Стоимость услуги - {{ absoluteBoxValue.Cost | moneyFormat }} руб. </span>
            <a v-show="absoluteBoxInfoFlag" :href="absoluteFileLink" target="_blank">Правила</a>
          </p>
        </div>
      </div>


      <div>
        <p><b>Правовая информация</b></p>
        <div id="legalBoxDesc">
          <p>В случае, если в таблице «Информация об услугах третьих лиц» мною проставлена отметка рядом с услугой,
            прошу перечислить часть займа в размере, составляющем стоимость дополнительной услуги, третьему лицу,
            предоставляющему соответствующую услугу. Я подтверждаю, что правила оказания услуг третьими лицами мне
            разъяснены и мною получены. Я уведомлен о том, что правила оказания третьими лицами услуг доступны в Личном
            кабинете заемщика. Я уведомлен о том, что приобретение услуг третьего лица не влияет на решение кредитора о
            предоставлении мне займа и на его условия. Я уведомлен о моем праве отказаться от услуги третьего лица в
            течение 30 календарных дней со дня выражения мною согласия на ее оказание посредством обращения к третьему
            лицу, оказывающему дополнительную услугу, с заявлением об отказе от такой услуги. Я также уведомлен, что
            вправе требовать от лица, оказывающего дополнительную услугу, возврата денежных средств, уплаченных за
            оказание такой услуги, за вычетом стоимости части такой услуги, фактически оказанной мне до дня получения
            лицом, оказывающим такую услугу, моего заявления об отказе от такой услуги. В случае, если третье лицо не
            исполняет обязанность по возврату мне денежных средств при отказе от дополнительной услуги, я вправе
            обратиться в ООО МКК «ФИНМОЛЛ» с заявлением о возврате денежных средств при отказе от дополнительной
            услуги.</p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instAgreement_easyconfirm",
  data() {
    return {
      agreementVisible: false,
      uiUrl: 'https://lk.msk.finmoll.com/public/confirm?request=' + localStorage.getItem('GUIDeasyConf'),
      pdnUrl: 'https://lk.msk.finmoll.com/public/pdnIl/' + localStorage.getItem('GUIDeasyConf'),
      anketaUrl: 'https://lk.msk.finmoll.com/public/pdnIl/' + localStorage.getItem('GUIDeasyConf'),
      absoluteBoxInfoFlag: false,
    }
  },
  components: {
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
  },
  methods: {
    agreementVisibleToggle($event) {
      $event.preventDefault();
      this.agreementVisible = !this.agreementVisible;
    },
    absoluteBoxInfo($event) {
      $event.preventDefault();
      this.absoluteBoxInfoFlag = true
    },
    cdAGREEMENT_ALL(value) {
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_EASY_DRAFT_IU',
        value: value
      });
    }
  },
  computed: {
    ...mapState({
      boxArr: state => state.instForm.boxArr,
      AGREEMENT_EASY_DRAFT_IU: state => state.Form.sendData.AGREEMENT_EASY_DRAFT_IU,
      AGREEMENT_PDN: state => state.Form.sendData.AGREEMENT_PDN,
      AGREEMENT_IU: state => state.Form.sendData.AGREEMENT_IU,
      AGREEMENT_ANKETA: state => state.Form.sendData.AGREEMENT_ANKETA,
      AGREEMENT_RECURENT: state => state.Form.sendData.AGREEMENT_RECURENT,
    }),
    absoluteBoxIndex() {
      return this.boxArr.findIndex((item) => item.Id === 4);
    },
    absoluteBoxValue: {
      get() {
        if (this.absoluteBoxIndex === -1) return null;
        return this.boxArr[this.absoluteBoxIndex];
      },
      set(newValue) {
        this.$store.commit('instUpdateBoxItem', {
          index: this.absoluteBoxValue,
          value: newValue
        })
      }
    },
    calcFill() {
      if (!this.absoluteBoxValue) return 'var(--color-gray-type2)';
      if (this.absoluteBoxValue.isActive !== 1 && this.absoluteBoxValue.isActive !== 0) {
        return 'var(--color-gray-type2)'
      }
      return this.absoluteBoxValue.isActive === 1 ? 'var(--color-green)' : 'var(--color-red-type2)';
    },
    absoluteFileLink() {
      return `${process.env.BASE_URL}pdf/Pravila_OOO_Absolyut_strahovaniya.pdf`;
    }
  },
  watch:{
    AGREEMENT_EASY_DRAFT_IU(newValue){
      if(newValue) {
        const arrFields = ['AGREEMENT_IU','AGREEMENT_PDN','AGREEMENT_ANKETA','AGREEMENT_RECURENT'];
        arrFields.forEach(item=>{
          this.$store.dispatch('saveSendData', {
            target: item,
            value: newValue
          });
        })
      }
    },
    AGREEMENT_IU(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_PDN && this.AGREEMENT_ANKETA && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_PDN(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_ANKETA && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_ANKETA(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_PDN && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_RECURENT(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_PDN && this.AGREEMENT_ANKETA){
        this.cdAGREEMENT_ALL(true);
      }
    },
  }
}
</script>

<style scoped>
.agreementDesc{margin-left: var(--font-size-10)}
#legalBoxDesc {
  width: 85%;
  height: 30vh;
  overflow: scroll;
  padding: var(--font-size-05);
  background: var(--color-gray-type2);
  font-size: var(--font-size-13);
  margin-top: var(--font-size-10)
}
</style>